import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from '../../../api';
import { addNote } from '../methods';
import { AddNoteRequest, AddNoteResponse } from '../types';

export const useAddNote = (): UseMutationResult<AddNoteResponse, unknown, AddNoteRequest> => {
  const queryClient = useQueryClient();
  return useMutation(addNote, {
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultation] }),
  });
};
